import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  menu: {
    '& li:not(:last-child)': {
      borderBottom: `1px solid ${Colors.Gray1}`,
    },
  },
  menuItem: {
    height: 58,
    '&:hover': {
      color: Colors.Blue1,
    },
  },
}));

export default useStyles;